export const environment = {
  production: true,
  STSSettings: {
    clientRoot: "https://gcv.ripley.com.pe",
    stsAuthority: "https://api-roles-perfiles.ripley.com.pe/apipyr/connect/v1/token",
    clientId: "webadmin",
    clientScope: "openid profile securityapi"
  },
  IdentityToken: "oidc.user:https://gcv.ripley.com.pe",
  RipleyApplicationAdminApiEndPoint: "https://api-roles-perfiles.ripley.com.pe/apipyr/security/application",
  RipleyApplicationUserAdminApiEndPoint: "https://api-roles-perfiles.ripley.com.pe/apipyr/security/user",
  RipleyUserAdminApiEndPoint:'https://api-roles-perfiles.ripley.com.pe/apisec/security',
  RipleyGiftCardVirtualApiEndPoint : "https://apigcv.ripley.com.pe"
}